module.exports = import("https://www.gstatic.com/firebasejs/9.17.2/firebase-analytics.js");;